<template>
  <div
      ref="dropdownMenu"
      class="nav-custom-dropdown"
      :class="{ 'nav-custom-dropdown-hover': visibleState }"
      @mouseover="handleChangeVisible(true)"
      @mouseleave="handleChangeVisible(false)"
  >
    <button
      :class="{ 'is-open': isOpen }"
      class="nav-dropdown__toggle nav-link"
      @click="handleDrop"
    >
      <span>{{ $t(selectedTitle) }}</span>
    </button>

    <div
      class="nav-dropdown-menu__wrapper nav-dropdown-menu--sm nav-dropdown-menu--lang"
      :class="{'has-scroll': (values.length > 9)}"
    >
      <div class="nav-dropdown-menu__inner">
        <ul class="nav-dropdown-list">
          <li v-for="item in values" :key="item.value" @click="handleItemClick(item)">
            <div
              :class="{ 'is-selected': item.value === selectedValue }"
              class="nav-dropdown-list__item"
            >
              <div class="nav-dropdown-list__item-main">
                <div class="nav-dropdown-list__item-title">
                  {{ $t(item.title) }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',

  props: {
    values: { type: [Object, Array], default: () => {} },
    selectedItem: { type: Object, default: () => {} },
  },

  data () {
    return {
      visibleState: false,
      isOpen: false,
    };
  },

  destroyed () {
    document.removeEventListener('click', this.handleCloseAll);
  },

  unmounted () {
    document.removeEventListener('click', this.handleCloseAll);
  },

  computed: {
    selectedTitle () {
      return this.selectedItem ? this.selectedItem.title : null;
    },

    selectedValue () {
      return this.selectedItem ? this.selectedItem.value : null;
    },
  },

  methods: {
    handleItemClick (item) {
      this.isOpen = !this.isOpen;
      this.visibleState = false;
      this.$emit('updated', item);
    },

    handleDrop (e) {
      e.preventDefault();
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        document.addEventListener('click', this.handleCloseAll);
      } else {
        document.removeEventListener('click', this.handleCloseAll);
      }
    },

    handleCloseAll (e) {
      const el = this.$refs.dropdownMenu;
      const target = e.target;
      if (el !== target && !el.contains(target)) {
        this.isOpen = false;
        document.removeEventListener('click', this.handleCloseAll);
      }
    },

    handleChangeVisible (state) {
      this.visibleState = state;
    },
  },
};
</script>

<style scoped lang="scss">
@use 'scss-vars';

  .nav-custom-dropdown {
    position: relative;
    max-height: 30px;

    .nav-dropdown-list {
      li {
        cursor: pointer;
      }
    }
  }

  .nav-link {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-family: scss-vars.$font-bold;
    font-size: 16px;
    line-height: 1;
    padding-bottom: 3px;
    padding-top: 6px;
    border-bottom: 3px solid transparent;
    transition: border-color 0.2s linear;

    .nav-custom-dropdown &:after {
      content: '\e901';
      @include scss-vars.inline-icon;
      font-size: 16px;
      width: 20px;
      transition: transform 0.2s linear;
    }

    & .icon {
      display: inline-block;
      font-size: 16px;
      width: 24px;
    }
  }

  .nav-dropdown-menu {
    &--lg {
      width: 320px;
    }

    &--md {
      width: 220px;
    }

    &--sm {
      width: 128px;
    }

    &--lang &__wrapper {
      left: -4px;
    }

    [dir='rtl'] &--lang &__wrapper {
      right: -4px;
      left: unset;
    }

    &__wrapper {
      position: absolute;
      left: -24px;
      top: 100%;
      z-index: 999;
      margin-top: 8px;
      border-radius: 10px;
      border: solid 1px scss-vars.$black;
      background-color: scss-vars.$white;
      box-shadow: 0px 3px 6px scss-vars.$black-15;
      padding: 12px 8px;
      opacity: 0;
      transform: translate3d(0, #{-4px}, 0);
      visibility: hidden;
      transition: opacity 0.2s linear, transform 0.2s linear,
      visibility 0s linear 0.2s;
    }

    [dir='rtl'] &__wrapper {
      right: -24px;
      left: unset;
    }

    &__wrapper:before {
      content: '';
      height: 8px;
      position: absolute;
      top: -8px;
      left: 0;
      right: 0;
    }

    &__title {
      font-family: scss-vars.$font-bold;
      font-size: 14px;
      line-height: 1.14;
      color: scss-vars.$black;
      padding: 8px 16px 12px 16px;
    }

    &__wrapper.has-scroll {
      padding-right: 0;
    }
  }

  .nav-dropdown-list {
    .has-scroll & {
      max-height: 376px;
      overflow-y: scroll;
    }

    &__item {
      display: flex;
      padding: 12px 16px;
      border-radius: 4px;
      transition: background-color 0.2s linear;
    }

    &__item:hover {
      background-color: scss-vars.$grey-04;
    }

    &__item.is-selected {
      background-color: scss-vars.$beige;
    }

    &__item-icon {
      display: inline-block;
      width: 32px;
      height: 32px;
    }

    &__item-icon + &__item-main {
      margin-left: 16px;
    }

    [dir='rtl'] &__item-icon + &__item-main {
      margin-right: 16px;
      margin-left: unset;
    }

    &__item-title {
      font-family: scss-vars.$font-bold;
      font-size: 16px;
      line-height: 1.25;
      color: scss-vars.$black;
    }

    &__item-subtitle {
      opacity: 0.4;
      font-size: 12px;
      line-height: 1.33;
      color: scss-vars.$black;
    }
  }

  .nav-custom-dropdown-hover {

    .nav-link {
      border-color: scss-vars.$black;

      &:after {
        transform: scaleY(-1);
      }
    }

    .nav-dropdown-menu__wrapper {
      transform: translate3d(0, 0, 0);
      opacity: 1;
      visibility: visible;
      transition: opacity 0.2s linear, transform 0.2s linear,
      visibility 0s linear 0s;
    }
  }
</style>
